import createReactClass from 'create-react-class';
import React from 'react';
import ReactDOM from 'react-dom';
import fetchImage from './fetch-image';
import Rectangle from './img/geometry';
import {
  getDefaultCrop,
  getDefaultCropRatio,
  getFixedCrop,
  scaleRectAroundOrigin,
} from './img/canvas';
import IU from './img/img-utils';
import CropCords from './img/thumbnail-crop-coords';

const imageProcessors = (function() {
  /** ************************************************************************************* */
  /* Constants */
  const { X, Y, WIDTH, HEIGHT, RIGHT_ANGLE, imgHelpers } = IU;

  /** ************************************************************************************* */
  /* Private Functions */

  const LocalThumbCache = {
    getThumb(url) {
      if (this.thumbs[url]) {
        return this.thumbs[url];
      }

      const img = fetchImage(url, 'anonymous');
      this.thumbs[url] = img;
      return img;
    },
    thumbs: {},
  };

  const PanHandle = new Image();
  PanHandle.src = '/wm/images/move-photo.png';
  const canvasId = 'pandaview-canvas';


  // -----------------------------------------------------------
  //  PandaView
  // -----------------------------------------------------------

  const PandaView = createReactClass({
    getInitialState() {
      return {
        forceCrop: false,
        drag: false,
        dragX: 0,
        dragY: 0,
        lastCrop: false,
        editMode: 'drag'
      };
    },
    componentDidMount() {
      this.checkImage();
      this.draw();
    },
    componentDidUpdate() {
      this.checkImage();
      if (this.simple_update) {
        this.draw();
      } else {
        this.queue_draw();
      }
    },
    UNSAFE_componentWillReceiveProps(nextProps) {
      const url_prop = 'large_url';

      if (this.props.editMode != nextProps.editMode) {
        this.setState({ editMode: nextProps.editMode });
      }

      this.pImg = null;

      if (
        nextProps.crop != this.props.crop ||
        nextProps.size_key != this.props.size_key ||
        nextProps.angle != this.props.angle ||
        nextProps[url_prop] != this.props[url_prop]
      ) {
        this.img_width = null;
        this.img_height = null;
        this.cacheKey = null;
        this.setState({ forceCrop: null });
      }

      this.simple_update =
        nextProps.crop != this.props.crop &&
        nextProps.angle == this.props.angle &&
        nextProps[url_prop] == this.props[url_prop];

      this.checkImage();
    },
    fullResoluton() {
      return this.prints_EL2() || this.printEditPreview();
    },
    prints_EL2() {
      return this.props.resolution === 'full';
    },
    printEditPreview() {
      return this.props.resolution === 'full-edit-preview';
    },
    ratio() {
      const {
        constraints: { ratio, prism },
        large_dimensions
      } = this.props;

      if (prism) {
        return ratio;
      }

      // if portrait or square image, then invert the ratio, as for those we apply the size ratio as portrait
      if (large_dimensions && large_dimensions.w <= large_dimensions.h) {
        return 1 / ratio;
      }

      return ratio;
    },
    render_EL2() {
      const maxWidth = IU.EL2_WIDTH;
      const maxHeight = IU.EL2_HEIGHT;
      const ratio = this.ratio();

      this.rect = Rectangle.fitLargestRectangle(ratio, maxWidth, maxHeight);

      this.rect[WIDTH] = Math.round(this.rect[WIDTH]);
      this.rect[HEIGHT] = Math.round(this.rect[HEIGHT]);

      // noinspection CheckTagEmptyBody
      return (
        <canvas
          ref="canvas"
          title={this.props.filename}
          width={this.rect[WIDTH] + 1}
          height={this.rect[HEIGHT] + 1}
          style={this.props.style}
          className="img-fluid ub-panda-view"
          onClick={this.props.onClick}
          onMouseDown={this.handleMouseDown}
          onMouseMove={this.handleMouseMove}
          onMouseUp={this.handleMouseGone}
          onTouchCancel={this.handleTouchEnd}
          onTouchEnd={this.handleTouchEnd}
          onTouchMove={this.handleTouchMove}
          onTouchStart={this.handleTouchStart}
        />
      );
    },
    renderPrintEditPreview() {
      const { cropEdges, filename, style } = this.props;
      let width = IU.EL2_WIDTH;
      let height = IU.EL2_HEIGHT;

      if (cropEdges) {
        const img = this.getImage();

        if (img) {
          const cropCords = new CropCords(
            img.crop,
            IU.imgHelpers.getPhotoAspectRatio(this.props)
          );
          width = cropCords.canvasWidth;
          height = cropCords.canvasHeight;
        }
      }

      return (
        <canvas
          ref="canvas"
          title={filename}
          width={width}
          height={height}
          style={style}
          className="full-edit-preview"
        />
      );
    },
    render() {
      if (this.prints_EL2()) {
        return this.render_EL2();
      }

      if (this.printEditPreview()) {
        return this.renderPrintEditPreview();
      }

      let width = IU.CANVAS_W;
      let height = IU.CANVAS_H;
      let classname = '';

      if (this.props.cropEdges) {
        const img = this.getImage();

        if (img) {
          const cropCords = new CropCords(
            img.crop,
            IU.imgHelpers.getPhotoAspectRatio(this.props)
          );
          width = cropCords.canvasWidth;
          height = cropCords.canvasHeight;

          classname = ' sized';
        }
      }

      // noinspection CheckTagEmptyBody
      return (
        <canvas
          ref="canvas"
          title={this.props.filename}
          width={width}
          height={height}
          style={this.props.style}
          className={`img-fluid ub-panda-view${classname}`}
          onClick={this.props.onClick}
          onMouseDown={this.handleMouseDown}
          onMouseMove={this.handleMouseMove}
          onMouseUp={this.handleMouseGone}
          onTouchCancel={this.handleTouchEnd}
          onTouchEnd={this.handleTouchEnd}
          onTouchMove={this.handleTouchMove}
          onTouchStart={this.handleTouchStart}
        />
      );
    },
    fixTouchEvent(e) {
      const [touch] = e.touches;

      if (touch) {
        return {
          ...e,
          pageX: touch.pageX,
          pageY: touch.pageY,
        };
      }
    },
    handleMouseDown(e) {
      // Only if we have a handler
      let viewScale;
      const zoom = this.getZoom();
      const {
        onClose,
        mode,
        editMode,
        raw_dimensions,
        large_dimensions,
        angle,
      } = this.props;
      const offset = $(this.refs.canvas).offset();
      let x = e.pageX - offset.left;
      let y = e.pageY - offset.top;

      if (this.activeArea) {
        if (x < this.activeArea[X]) {
          if (onClose) onClose();
          return;
        }
        if (x > this.activeArea[X] + this.activeArea[WIDTH]) {
          if (onClose) onClose();
          return;
        }
        if (y > this.activeArea[Y] + this.activeArea[HEIGHT]) {
          if (onClose) onClose();
          return;
        }
      }

      //* **************************************************************
      // Editing Mode
      if (mode === 'editing') {
        this.setState({
          forceCrop: this.getCrop(),
          lastCrop: this.getCrop(),
          drag: true,
          dragX: e.pageX,
          dragY: e.pageY,
        });
      }
    },
    handleTouchStart(e) {
      this.handleMouseDown(this.fixTouchEvent(e));
    },
    shouldHandleMove() {
      return this.props.mode == 'editing' && this.state.drag;
    },
    handleMouseMove(e) {
      if (this.shouldHandleMove()) {
        e.preventDefault();
        const dX = e.pageX - this.state.dragX;
        const dY = e.pageY - this.state.dragY;
        const scale = this.viewScale();

        this.handlePan(-1 * dX * scale, -1 * dY * scale);
        this.setState({
          dragX: e.pageX,
          dragY: e.pageY,
        });
      }
    },
    handleTouchMove(e) {
      if (this.shouldHandleMove()) {
        this.handleMouseMove(this.fixTouchEvent(e));
      }
    },
    handleMouseGone(e) {
      this.setState({ drag: false });
      if (this.overlay) {
        this.overlay.off();
        this.overlay.remove();
        jQuery(document.body).css('user-select', '');
        this.overlay = null;
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      if (this.state.lastCrop) {
        this.props.onCropChanged &&
          this.props.onCropChanged(this.state.lastCrop);
        this.setState({ lastCrop: false });
      }
    },
    handleTouchEnd(e) {
      this.handleMouseGone(this.fixTouchEvent(e));
    },
    checkImage() {
      let url;
      let cache = false;
      const url_prop = 'large_url';

      if (this.fullResoluton()) {
        if (!this.props[url_prop]) {
          return;
        }
        url = this.props[url_prop].replace(/^https?:/, '');
      } else if (this.props.thumb_url) {
        url = this.props.thumb_url.replace(/^https?:/, '');
        cache = true;
      }

      if (this.img && this.url == url) {
      } else {
        this.url = url;
        if (cache) {
          this.img = LocalThumbCache.getThumb(url);
        } else if (window.RawCache) {
          this.img = RawCache.get(url);
        } else {
          this.img = fetchImage(url, 'anonymous');
        }

        const self = this;
        const queue_draw = function() {
          // Needs to re-render the component after the image have been succesfully loaded in order for the canvas to
          // be resized correctly.
          self.forceUpdate(function() {
            self.queue_draw();

            if (self.props.onImageLoaded) {
              self.props.onImageLoaded();
            }
          });
        };
        if (this.img.complete) {
          window.requestAnimationFrame(queue_draw);
        }
        this.img.addEventListener('load', queue_draw);
      }
    },
    viewScale() {
      const canvas = this.refs.canvas;
      if (canvas) {
        return canvas.width / canvas.clientWidth;
      }
      return 1;
    },
    queue_draw() {
      if (!this.tID) {
        this.bound_draw = this.bound_draw || this.draw;
        this.tID = setTimeout(this.bound_draw, 150);
      }
    },
    getCacheKey() {
      let cacheKey = `-img-${[
        this.img.src,
        this.props.size_key,
        this.props.angle,
        this.props.straighten,
        this.props.gamma,
        this.props.fx,
      ].join('-')}`;

      return cacheKey;
    },
    getProcessedImage() {
      let img = this.img;

      if (img && img.complete) {
        const cacheKey = this.getCacheKey();

        if (this.cachedImage && this.cacheKey == cacheKey) {
          return this.cachedImage;
        }

        const crop = this.getCrop();
        const ratio = crop[WIDTH] / crop[HEIGHT];
        const scale = 1;

        const props = {
          angle: this.props.angle,
          straighten: this.props.straighten,
          gamma: this.props.gamma,
          fx: this.props.fx,
        };

        if (this.props.constraints && this.props.constraints.prism) {
          props.angle = RIGHT_ANGLE * 4 - props.angle;
        }

        props.eye_scale = this.getScale();
        img = imgHelpers.doProcessPhoto(img, props, ratio, scale);

        this.cachedImage = img;
        this.cacheKey = cacheKey;

        return img;
      }
    },
    getImage() {
      if (this.img && this.img.src && this.img.complete) {
        this.pImg = this.pImg || this.getProcessedImage();

        const scale = (() => {
          const scale = this.getScale();

          return value => {
            value = parseInt(value, 10) * scale;

            return isNaN(value) ? 1 : value;
          };
        })();

        const img = this.pImg;

        img.crop = features?.disableAutoPrintCropping && !this.props.crop
          ? [0, 0, img.width, img.height]
          : this.getCrop().map(scale);

        img.cropped = false;

        return img;
      }

      this.pImg = null;
    },
    draw() {
      const canvas = this.refs.canvas;
      if (!canvas) {
        return;
      }

      const img = this.getImage();
      this.tID = null;

      if (!this.img || !this.img.complete || !img) {
        const ctx = canvas.getContext('2d');
        ctx.save();
        ctx.rect(
          canvas.width / 4,
          canvas.height / 4,
          canvas.width / 2,
          canvas.height / 2
        );
        ctx.fillStyle = 'transparent';
        ctx.fill();

        ctx.restore();
        return;
      }

      if (this.prints_EL2()) {
        return this.draw_EL2(canvas, img);
      }

      try {
        this.props.mode === 'editing'
          ? this.draw_editable()
          : this.draw_preview();
      } catch (e) {
        console.error(e);
      }
    },
    get_CropRatio() {},
    draw_EL2(canvas, img) {
      if (!canvas) return;
      if (!img) return;

      const dx = 1;
      const dy = 1;
      const dw = this.rect[WIDTH];
      const dh = this.rect[HEIGHT];

      const crop =
        img.crop ||
        getDefaultCrop(
          this.props.size_area[X] / this.props.size_area[Y],
          img.width,
          img.height
        );

      const ctx = canvas.getContext('2d');

      this.last_draw = {
        x: dx,
        y: dy,
        crop,
      };

      ctx.drawImage(
        img,
        Math.floor(crop[X]),
        Math.floor(crop[Y]),
        Math.floor(crop[WIDTH]),
        Math.floor(crop[HEIGHT]),
        dx,
        dy,
        dw,
        dh
      );

      ctx.beginPath();
      ctx.rect(dx, dy, dw, dh);
      ctx.strokeStyle = '#ffc120';
      ctx.lineWidth = 3;
      ctx.stroke();
      this.draw_handle({ ctx, canvas, x: dx, y: dy, cropFrame: this.rect });
    },
    draw_outline(ctx, rectangle, dimensions) {},
    draw_preview() {
      const canvas = ReactDOM.findDOMNode(this.refs.canvas);
      if (!canvas) return;

      let img = this.getImage();
      if (!img) return;

      const crop =
        img.crop ||
        getDefaultCrop(
          this.props.size_area[X] / this.props.size_area[Y],
          img.width,
          img.height
        );
      img = img.cloneRectangle(
        crop,
        IU.imgHelpers.getPhotoAspectRatio(this.props)
      );

      const ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.save();

      let x = 0;
      const y = 0;

      const scale =
        img.height / img.width < canvas.height / canvas.width
          ? canvas.width / img.width
          : canvas.height / img.height;
      if (scale * img.width < canvas.width) {
        x = (canvas.width - scale * img.width) / 2;
        ctx.translate(x, 0);
      }
      ctx.scale(scale, scale);

      ctx.drawImage(img, 0, 0);
      ctx.restore();

      const viewScale = canvas.clientWidth / canvas.width;
      const outline = [x, y, scale * img.width, scale * img.height];
      this.reportSize(
        viewScale * x,
        viewScale * y,
        viewScale * (x + outline[WIDTH]),
        viewScale * (y + outline[HEIGHT])
      );
    },
    reportSize(x1, y1, x2, y2) {
      if (
        this.last_size &&
        this.last_size[X] === x2 &&
        this.last_size[Y] === y2
      ) {
        return;
      }

      this.widgetSize = [x1, y1, x2, y2];
      if (this.props.onSize) {
        const self = this;
        this.last_size = [x2, y2];
        setTimeout(function() {
          self.props.onSize(x2, y2, x1, y1);
          self.forceUpdate();
        }, 5);
      }
    },
    draw_editable() {
      const canvas = ReactDOM.findDOMNode(this.refs.canvas);
      if (!canvas) return;

      let img = this.getImage();
      if (!img) return;

      const crop =
        img.crop ||
        getDefaultCrop(
          this.props.size_area[X] / this.props.size_area[Y],
          img.width,
          img.height
        );
      img = img.cloneRectangle(
        crop,
        IU.imgHelpers.getPhotoAspectRatio(this.props)
      );

      const ctx = canvas.getContext('2d');
      ctx.beginPath();
      ctx.save();

      let x = 0;
      const y = 0;

      const scale =
        img.height / img.width < canvas.height / canvas.width
          ? canvas.width / img.width
          : canvas.height / img.height;
      if (scale * img.width < canvas.width) {
        x = (canvas.width - scale * img.width) / 2;
        ctx.translate(x, 0);
      }
      ctx.scale(scale, scale);

      ctx.drawImage(img, 0, 0);
      ctx.restore();

      const viewScale = canvas.clientWidth / canvas.width;
      const outline = [x, y, scale * img.width, scale * img.height];
      this.reportSize(
        viewScale * x,
        viewScale * y,
        viewScale * (x + outline[WIDTH]),
        viewScale * (y + outline[HEIGHT])
      );

      ctx.rect(outline[X], outline[Y], outline[WIDTH], outline[HEIGHT]);
      ctx.strokeStyle = '#ffc120';
      ctx.lineWidth = 3 / viewScale;
      ctx.stroke();

      const draw = {
        canvas,
        img,
        outline,
        scale,
        cropFrame: outline,
        ctx,
      };
      this.draw_handle(draw);

      this.last_draw = draw;
    },
    draw_handle(draw) {
      if (
        this.props.mode == 'editing' &&
        this.canPan() &&
        PanHandle.complete &&
        !PanHandle.error &&
        !this.state.drag
      ) {
        if (!this.panHandleSince) {
          this.panHandleSince = new Date().getTime();
        }
        let phw = draw.canvas.width;
        if (draw.x) {
          phw -= draw.x * 2;
        }
        const phh = draw.cropFrame[HEIGHT] + 2 * draw.cropFrame[Y];
        let handle_scale = 1.0;
        if (this.fullResoluton()) {
          handle_scale = draw.canvas.width / ( draw.canvas.clientWidth * 2 );
        }
        const now = new Date().getTime();

        const fade = 5;
        const alpha = fade - ( now - this.panHandleSince ) / 1000;
        if (alpha < 0) {
          return;
        }
        draw.ctx.save();
        draw.ctx.globalAlpha = alpha;
        draw.ctx.translate(phw / 2, phh / 2, 'pwh,pwh - draw_handle');
        draw.ctx.scale(handle_scale, handle_scale);

        draw.ctx.drawImage(
          PanHandle,
          (0 - PanHandle.width) / 2,
          (0 - PanHandle.height) / 2
        );
        draw.ctx.restore();
        const self = this;
        setTimeout(function() {
          self.draw();
        }, 50);
      } else if (this.canPan() === false) {
        // reset pan status
        this.panHandleSince = null;
      }
    },
    defaultCrop() {
      return this.defaultCropForAngle(this.props.angle);
    },
    defaultCropForAngle(angle) {
      const { raw_dimensions: rawDimensions } = this.props;

      if (!rawDimensions) {
        return [0, 0, 1, 1];
      }

      const { size_area, size, constraints = {} } = this.props;
      const area = ( size_area || size.area );
      let { w, h } = rawDimensions;

      const ratio = constraints.prism
        ? constraints.ratio // already rotated
        : getDefaultCropRatio(area[X] / area[Y], w, h);

      if (angle % ( 2 * RIGHT_ANGLE ) === RIGHT_ANGLE) {
        [h, w] = [rawDimensions.w, rawDimensions.h];
      }

      return getFixedCrop(ratio, w, h);
    },
    getCrop() {
      if (this.state.forceCrop) {
        return this.state.forceCrop;
      }

      if (typeof this.props.crop === 'string') {
        return this.props.crop.split(/,/).map(parseInt);
      }

      if (Array.isArray(this.props.crop) && this.props.crop.length == 4) {
        return this.props.crop;
      }

      return this.defaultCrop();
    },
    getZoom() {
      const defaultCrop = this.defaultCrop();
      const crop = this.getCrop();
      const zoom = defaultCrop[WIDTH] / crop[WIDTH]; // TODO - is this broken ??

      if (isNaN(zoom)) return IU.DEF_ZOOM;
      if (zoom > IU.MAX_ZOOM) return IU.MAX_ZOOM;
      if (zoom < IU.MIN_ZOOM) return IU.MIN_ZOOM;

      return zoom;
    },
    getScale() {
      if (this.img && this.img.complete && this.img.width) {
        return this.img.width / this.props.raw_dimensions.w;
      }

      return this.fullResoluton()
        ? this.props.large_dimensions.w / this.props.raw_dimensions.w
        : this.props.thumb_dimensions.w / this.props.raw_dimensions.w;
    },
    canPan() {
      if (!this.img) return null;
      const crop = this.getCrop();
      const area = this.props.raw_dimensions.w * this.props.raw_dimensions.h;
      const crop_area = crop[WIDTH] * crop[HEIGHT];
      const percentage = (crop_area / area) * 100;
      return percentage < 98 || percentage > 102;
    },

    handlePan(dx, dy) {
      const crop = this.getCrop();
      const scale = this.getScale();
      const { raw_dimensions, angle } = this.props;
      let w;
      let h;

      w = raw_dimensions.w;
      h = raw_dimensions.h;

      if (angle % (2 * RIGHT_ANGLE) === RIGHT_ANGLE) {
        h = raw_dimensions.w;
        w = raw_dimensions.h;
      }

      const crop2 = [
        crop[X] + dx / scale,
        crop[Y] + dy / scale,
        crop[WIDTH],
        crop[HEIGHT],
      ];
      if (crop2[X] + crop2[WIDTH] > w) {
        crop2[X] = w - crop2[WIDTH];
      }
      if (crop2[Y] + crop[HEIGHT] > h) {
        crop2[Y] = h - crop2[HEIGHT];
      }
      if (crop2[X] < 0) {
        crop2[X] = 0;
      }
      if (crop2[Y] < 0) {
        crop2[Y] = 0;
      }

      this.setState({ forceCrop: crop2, lastCrop: crop2 });
    },
    componentWillUnmount() {
      clearTimeout(this.tID);
    },
  });

  // -----------------------------------------------------------
  //  PandaTweaker
  // -----------------------------------------------------------

  const PandaTweaker = createReactClass({
    getInitialState() {
      return {};
    },
    init() {
      // no-op
    },
    render() {
      const props = {};
      for (const k in this.state) props[k] = this.state[k];
      props.cropRatio = this.props.constraints.crop_ratio;
      const styles = {
        width: 'auto',
        maxHeight: this.props.height,
      };

      return (
        <div className="ub-image-tweaker text-center">
          <PandaView
            {...props}
            ref="printview"
            mode="editing"
            editMode={this.props.editMode}
            style={styles}
            resolution="full"
            constraints={this.props.constraints}
            onImageLoaded={this.props.onImageLoaded}
            onChange={this.props.onChange}
            onCropChanged={this.onCropChanged}
          />
        </div>
      );
    },
    onCropChanged(settings) {
      this.mutate({ crop: this.refs.printview.getCrop() });
    },
    cropCentre() {
      const crop = this.state.crop || this.refs.printview.defaultCrop();

      const x = crop[X];
      const y = crop[Y];
      const w = crop[WIDTH];
      const h = crop[HEIGHT];

      return { y: h / 2 + y, x: w / 2 + x };
    },
    doZoom(zoomLevel, callback) {
      if (!this.state.raw_dimensions) return; // Sometimes spuriously triggered !

      let w = this.state.raw_dimensions.w;
      let h = this.state.raw_dimensions.h;

      if (this.state.angle % (2 * RIGHT_ANGLE) === RIGHT_ANGLE) {
        h = this.state.raw_dimensions.w;
        w = this.state.raw_dimensions.h;
      }

      const r = this.refs.printview.defaultCrop();

      const centre = this.cropCentre();

      const newCrop = scaleRectAroundOrigin(
        { x: w / 2, y: h / 2 },
        r,
        1 / zoomLevel
      );
      let newX = centre.x - newCrop[WIDTH] / 2;
      let newY = centre.y - newCrop[HEIGHT] / 2;

      if (newX < 0) {
        newX = 0;
      }
      if (newY < 0) {
        newY = 0;
      }

      if (newX + newCrop[WIDTH] > w) {
        newX -= newX + newCrop[WIDTH] - w;
      }
      if (newY + newCrop[HEIGHT] > h) {
        newY -= newY + newCrop[HEIGHT] - h;
      }

      if (newX + newCrop[WIDTH] > w) {
        newX = w - newCrop[WIDTH];
      }
      if (newY + newCrop[HEIGHT] > h) {
        newY = h - newCrop[HEIGHT];
      }

      newCrop[X] = newX;
      newCrop[Y] = newY;

      this.mutate({ crop: newCrop }, callback);
    },
    mutate(value, callback) {
      const after = function() {
        if (callback) callback(value);
        if (this.props.onChange) {
          this.props.onChange();
        }
      }.bind(this);
      // Always save crop
      value.crop = value.crop || this.refs.printview.getCrop();
      this.setState(value, after);
    },
    getZoom() {
      return this.refs.printview.getZoom();
    },
    setStraighten(value) {
      this.mutate({ straighten: value });
    },
    setGamma(value) {
      this.mutate({ gamma: value });
    },
    rotateImage(value) {
      let angle = 0;
      if (this.state.angle) angle = this.state.angle;
      const zoom = this.getZoom();
      let newAngle = (angle - value) % 360;
      while (newAngle < 0) {
        newAngle += 360;
      }
      this.mutate(
        { angle: newAngle },
        function() {
          this.doZoom(zoom);
        }.bind(this)
      );
    },
    setFX(value) {
      this.mutate({ fx: value });
    },
    getPrintsSettings() {
      return this.state;
    },
    setPrintsSettings(settings, callback) {
      this.setState(settings, function() {
        callback && callback();
      });
      this.refs.printview.panHandleSince = new Date().getTime();
    },
  });

  return {
    PanHandle,
    PandaView,
    PandaTweaker,
  };
})();

export const PanHandle = imageProcessors.PanHandle;

export const PandaView = imageProcessors.PandaView;

export const PandaTweaker = imageProcessors.PandaTweaker;
